import { Component } from '@angular/core';
import { AppHeaderComponent } from '../../../layout-components/headers/app-header/app-header.component';
import { RouterOutlet } from '@angular/router';
import { AppFooterComponent } from '../../../layout-components/footers/app-footer/app-footer.component';

@Component({
  selector: 'bor-extranet-layout',
  imports: [
    AppHeaderComponent,
    RouterOutlet,
    AppFooterComponent
  ],
  templateUrl: './extranet-layout.component.html',
  styleUrl: './extranet-layout.component.scss',
})
export class ExtranetLayoutComponent {}
